const { SingleSelectPrototype } = require("./prototypes");

// deprecated - use RadioButtonType instead
function RadioType() {
  this.type = "radio";

  this.validate = ({ eligibility, answer }) =>
    Array.isArray(eligibility) &&
    (eligibility.includes(answer) || eligibility.length < 1);
}
RadioType.prototype = SingleSelectPrototype;

module.exports = RadioType;
